import React from 'react';
import { useSelector } from 'react-redux';
import logo from '@assets/images/Logo.png';
import { Link } from 'react-router-dom';
import { PageState } from '@store/page';
import '../../../styles/beta-flag.css';

import { HeaderTypes } from './types';
import HeaderTopbar from './HeaderTopBar';

export const Header: React.FunctionComponent<HeaderTypes> = React.memo(() => {
    const pageState = useSelector(({ page }: { page: PageState }) => page);

    return (
        <div className="header align-items-stretch">
            <div className="header-brand align-items-center justify-content-center" style={{ zIndex: 2 }}>
                <Link to="/dashboard" className="d-flex justify-content-center w-100 pt-4 position-relative">
                    <img
                        alt="Logo"
                        src={logo}
                        style={{
                            maxWidth: '180px',
                            width: '75%',
                            height: 'auto',
                            minWidth: '80px',
                        }}
                    />
                    <span className="beta-flag">Beta</span>
                </Link>
            </div>
            <div className="topbar">
                <HeaderTopbar pageTitle={pageState.title} />
            </div>
        </div>
    );
});

Header.displayName = 'Header';

export default Header;
